<script setup lang="ts">
import type { SpacerBlockV2Schema } from 'types/storyblok/spacer-block-v2'

defineProps<{ blok: SpacerBlockV2Schema }>()
</script>

<template>
  <div class="spacer-block-v2" />
</template>

<style scoped>
.spacer-block-v2 {
  padding: var(--spacing-s);
}
</style>
